'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$$anon$15() {
}
export { $c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$$anon$15 as $c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$$anon$15 };
$c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$$anon$15.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$$anon$15.prototype.constructor = $c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$$anon$15;
/** @constructor */
function $h_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$$anon$15() {
}
export { $h_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$$anon$15 as $h_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$$anon$15 };
$h_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$$anon$15.prototype = $c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$$anon$15.prototype;
$c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$$anon$15.prototype.compose__F1__F1 = (function(g) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_F1__compose__F1__F1(this, g);
});
$c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$$anon$15.prototype.andThen__F1__F1 = (function(g) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_F1__andThen__F1__F1(this, g);
});
$c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$$anon$15.prototype.toString__T = (function() {
  return "<function1>";
});
$c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$$anon$15.prototype.apply__O__O = (function(v1) {
  return v1;
});
$c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$$anon$15.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return v1;
});
var $d_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$$anon$15 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$$anon$15, "app.api.DrugRequestsAcceptedListItem$ProvidedEPSCode$$anon$15", ({
  Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$$anon$15: 1,
  F1: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction1: 1
}));
export { $d_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$$anon$15 as $d_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$$anon$15 };
//# sourceMappingURL=app.api.-Drug-Requests-Accepted-List-Item$-Provided-E-P-S-Code$$anon$15.js.map
